<div class="row">
	<div class="col col-4"><span i18n="Common|Length">Length</span>:</div>
	<div class="col col-8">
		<app-numeric-textbox [value]="current.getLength()" [disabled]="true"></app-numeric-textbox> mm
	</div>
</div>

<div class="row">
	<div class="col col-4">
		<span i18n="Common|Location x">Location x</span>:
	</div>

	<div class="col col-8">
		<app-numeric-textbox [value]="currentProfileLocation" [disabled]="true"></app-numeric-textbox> mm
	</div>
</div>

<card-cuttingonsite [current]="current" [disabled]="checkFreezingElements()"></card-cuttingonsite>
<card-in-offer [current]="current"></card-in-offer>

<div *ngIf="projectService.showDebugInfo" class="testMode">
	<div class="row">
		<div class="col col-4">Tag:</div>
		<div class="col col-8">{{ current.tag }}</div>
	</div>
	<div class="row">
		<div class="col col-4">Id:</div>
		<div class="col col-8">{{ current.id }}</div>
	</div>
	<div class="row">
		<div class="col col-4">Columns:</div>
		<div class="col col-8">
			<p *ngFor="let c of current.columns">
				{{ c.tag}}: {{ c.id }}
			</p>
		</div>
	</div>
</div>